// utils/canonicalSpecs.js

export const CANON_SPEC = {
  required: [
    {
      key: 'Message',
      desc: 'Full text of the post/tweet; keep emojis, mentions, newlines; plain text; no truncation.',
      example: 'RT @vladimirputiniu President Putin has ordered to...'
    },
    {
      key: 'CreatedTime',
      desc: 'Creation timestamp; ISO-like `YYYY-MM-DD[ T]HH:mm:ss[.fff]` (with Z/±offset or none), ' +
        'US `MM/DD/YYYY hh:mm:ss AM/PM`, or Excel date values.\n',
      example: '2025-06-05 12:28:18.262'
    },
    {
      key: 'SenderScreenName',
      desc: 'Handle/username; 2–32 chars [A–Z a–z 0–9 _ .]; "@" optional; not all digits.',
      example: 'Isabelle0071'
    },
    {
      key: 'OriginalPostId',
      desc: 'Steam app/game identifier for the reviewed product. Numeric AppID (e.g., 570 for Dota 2).',
      example: '570'
    }
  ],
  optional: [
    {
      key: 'Permalink',
      desc: 'Direct URL to the specific post; absolute URL starting with https://',
      example: 'https://twitter.com/Isabelle0071/status/1930602578624090504'
    },
    {
      key: 'SenderUserId',
      desc: 'Numeric platform user ID; digits only; 6+ digits; no commas/quotes.',
      example: '2792466840'
    },
    {
      key: 'Message Type',
      desc: 'Interaction type (enum). Use one of: "X Repost" | "X Mention" | "X Reply" | "X Update".',
      example: 'X Repost'
    },
    {
      key: 'OriginalAuthor',
      desc: 'Source account for repost/quote/reply; handle/username; same rules as SenderScreenName; blank if N/A.',
      example: 'vladimirputiniu'
    },
    {
      key: 'SenderProfileImgUrl', 
      desc: 'Profile image URL at capture time; absolute URL starting with https://',
      example: 'https://pbs.twimg.com/profile_images/.../Z9jn4n0w_normal.jpg'
    },
    
    {
      key: 'Sender Followers Count',
      desc: 'Follower count at capture time; integer ≥ 0; no commas; no text.',
      example: '612'
    },
    {
      key: 'Tweet Generator',
      desc: 'Publishing client/app; short string.',
      example: 'Twitter for iPhone'
    },
    {
      key: 'Title',
      desc: 'For Reddit titles/headlines; short string; blank if N/A.',
      example: 'Will climate change make Arizona unlivable?, Got some earthquake in Johor'
    },
    {
      key: 'author_playtime_forever',
      desc: 'Total cumulative playtime of the reviewing user for the game, measured in minutes. Non-negative integer, no commas or text.',
      example: '12876'
    },
    {
      key: 'author_playtime_forever',
      desc: 'Total cumulative playtime (in minutes) of the reviewing user for the game at the time of data capture. Integer ≥ 0, no commas or text.',
      example: '12876'
    },
    {
      key: 'SenderProfilePrivacyStatus',
      desc: 'Privacy setting of the user’s profile at the time of capture. Typical values: "public", "private", or "friends-only". Case-insensitive string.',
      example: 'public'
    },
    {
      key: 'Country',
      desc: 'Geographic country associated with the sender or account at the time of capture. ISO country name or code preferred; free-text if unavailable.',
      example: 'United States'
    },
    {
      key: 'SenderProfileCreationDate',
      desc: 'Account creation date; ISO-like `YYYY-MM-DD[ T]HH:mm:ss[.fff]` (with Z/±offset or none)',
      example: '2020-11-15 08:45:30, 2011-04-11T21:58:29Z'
    },
    {
      key: 'OriginalPostDescription',
      desc: 'For YouTube video texts: description text of the video; plain text; no truncation.',
      example: 'Check out my latest vlog about my trip to Japan! #travel #vlog'
    },
    {
      key: 'OriginalPostId',
      desc: 'Unique identifier for the original post; alphanumeric string; no special characters.',
      example: 'dQw4w9WgXcQ'
    },
    {
      key: 'TotalPosts',
      desc: 'Total number of posts made by the sender; integer ≥ 0; no commas or text.',
      example: '1540'
    },
    {
      key: 'SenderProfileBannerUrl',
      desc: 'Profile banner image URL at capture time; absolute URL starting with https://',
      example: 'https://pbs.twimg.com/profile_banners/.../1500x500'
    },
    {
      key: 'PostsCount',
      desc: 'Total number of posts made by the sender; integer ≥ 0; no commas or text.',
      example: '1540'
    },
    {
      key: 'SenderProfileDesc',
      desc: 'Profile description/bio at capture time; plain text; no truncation.',
      example: 'Tech enthusiast. Love hiking and photography. Coffee addict.'
    },
    {
      key: 'AccountCreated',
      desc: 'Account creation date; ISO-like `YYYY-MM-DD[ T]HH:mm:ss[.fff]` (with Z/±offset or none)',
      example: '2020-11-15 08:45:30, 2011-04-11T21:58:29Z'
    },
    {
      key: 'SenderReputation',
      desc: 'Reputation score or level of the sender/account at the time of capture; numeric or short string.',
      example: '4.5, 87'
    },
    {
      key: 'SenderProfileCreationDate',
      desc: 'Account creation date; ISO-like `YYYY-MM-DD[ T]HH:mm:ss[.fff]` (with Z/±offset or none)',
      example: '2020-11-15 08:45:30, 2011-04-11T21:58:29Z'
    }
  ]
};
    
 
// Optional: one-line explainer for your UI tooltip/banner
export const MAPPING_WHY = `Mapping tells the system which of your columns equals each required field.
It ensures Message/CreatedTime/SenderScreenName exist and are named consistently, so the pipeline can parse, group, and analyze reliably (no guesswork).`;


// export const PLATFORM_FIELD_NOTES = {
//   reddit: {
//     Title: 'Reddit posts/comments often require a Title column (post title). If you only have comments, map Title to a short derived text or leave blank where N/A.'
//   },
//   steam: {
//     OriginalPostId: 'Steam game/app id for the reviewed product. Ensure this is numeric and consistent.',
//     // '<<ADD_2>>': 'Describe the second steam required field',
//     // '<<ADD_3>>': 'Describe the third steam required field',
//   }
// };